import { ShiftManagementSelectableEmployeesByCurrentDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { useLedEmployeesByCurrent } from './useLedEmployeesByCurrent'
import { usePermissions } from './usePermissions'

type Result = {
  loading: boolean
  employeeIds: number[]
}

// Employees I have permissions to create shifts
//
// Need to create a query to get this data, we don't seem to have it right now. EXPLORE
//
// Since this is only used in the ImportEmployeesModal, we can merge it.
export function useSelectableEmployeesByCurrent(): Result {
  const { employee: currentEmployee, allMyDescendants, company } = useCurrentSession()
  const [
    {
      canCreateShiftsForEverybody,
      canCreateShiftsForTeam,
      canCreateShiftsForReportees,
      canCreateShiftsForSelf,
    },
  ] = usePermissions()

  const { data, loading } = useQuery(ShiftManagementSelectableEmployeesByCurrentDocument, {
    variables: {
      companyId: company.id,
    },
    skip: !canCreateShiftsForEverybody,
  })

  const allEmployeeIds = data?.employees.employeeNames.map((employee) => employee.id) ?? []

  const { ledEmployees, loading: loadingLedEmployees } = useLedEmployeesByCurrent({
    skip: canCreateShiftsForEverybody || !canCreateShiftsForTeam,
  })

  // Replace this call with an `employeeNames{id}`
  if (canCreateShiftsForEverybody) return { loading: loading, employeeIds: allEmployeeIds }

  let list = currentEmployee && canCreateShiftsForSelf ? [currentEmployee.id] : []

  if (!currentEmployee) return { loading: false, employeeIds: list }

  if (canCreateShiftsForReportees) {
    list = list.concat(allMyDescendants)
  }

  if (canCreateShiftsForTeam) {
    list = list.concat(ledEmployees)
  }

  return {
    loading: loadingLedEmployees,
    employeeIds: [...new Set(list)],
  }
}
